import React, { useState, useRef, useEffect } from 'react';
import DropDownBox from 'devextreme-react/drop-down-box';
import TreeView from 'devextreme-react/tree-view';
import PropTypes from 'prop-types';

const NewsDropDown = ({ dataSource, value, onValueChanged, selectionMode = null, updateSeoLink = null }) => {
    const treeView = useRef(null);
    const [treeBoxValue, setTreeBoxValue] = useState([]);
    useEffect(() => {
        if (value) {
            if (selectionMode === 'single') {
                setTreeBoxValue([value]);
            } else {
                setTreeBoxValue(value);
            }
        }
    }, [value, selectionMode]);
    
    const treeViewItemSelectionChanged = (e) => {
        const _value = e.component.getSelectedNodeKeys();
        setTreeBoxValue(_value);

        if (updateSeoLink !== null) {
            if (_value.length > 0) {
                const _selectedNews = dataSource.find(x => x.id === _value[0]);
                updateSeoLink(_selectedNews.seoLink);
            } else {
                updateSeoLink('');
            }
        }
    };

    const treeViewRender = () => {
        return (
            <TreeView
                dataSource={dataSource}
                ref={treeView}
                dataStructure="plain"
                keyExpr="id"
                parentIdExpr="parentId"
                selectionMode={selectionMode || 'multiple'}
                showCheckBoxesMode="normal"
                selectNodesRecursive={false}
                displayExpr="name"
                selectByClick={true}
                onContentReady={syncTreeViewSelection}
                onItemSelectionChanged={treeViewItemSelectionChanged}
            />
        );
    };

    const syncTreeViewSelection = (e) => {
        const _treeView = (e.component.selectItem && e.component) || (treeView && treeView.current);
        if (_treeView) {
            if (e.value === null) {
                _treeView.instance.unselectAll();
            } else {
                const values = e.value || treeBoxValue;
                values && values.forEach(function (value) {
                    _treeView.selectItem(value);
                });
            }
        }
        if (e.value !== undefined) {
            setTreeBoxValue(e.value);
        }
    };
   const onClosed=()=>{
       onValueChanged(treeBoxValue || []);
   }
    return (
        <React.Fragment>
            <DropDownBox
                value={treeBoxValue}
                valueExpr="id"
                displayExpr="name"
                placeholder="Select a value..."
                // showClearButton={true}
                dataSource={dataSource}
                onValueChanged={syncTreeViewSelection}
                contentRender={treeViewRender}
                onClosed={onClosed}
            />
        </React.Fragment>
    );
};

NewsDropDown.propTypes = {
    dataSource: PropTypes.array,
    value: PropTypes.array,
    onValueChanged: PropTypes.func,
    selectionMode: PropTypes.string,
    updateSeoLink: PropTypes.func
};

export default NewsDropDown;
